import { LabelVisibility } from '@aibees/elephant/types/label';

export function useLabelVisibilityStatus(checked: boolean) {
  return checked ? LabelVisibility.PRIVATE : LabelVisibility.INTERNAL;
}
